import { render, staticRenderFns } from "./CreateUserFileSource.vue?vue&type=template&id=060aede6"
import script from "./CreateUserFileSource.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateUserFileSource.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports